var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadings"},[_c('iconSymbol',{staticStyle:{"width":"32px","height":"32px"},attrs:{"name":"loading"}}),_c('span',[_vm._v(_vm._s(_vm.$t("loading")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }